import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/Subject'
import { Component } from '@angular/core';
import { $BroadcastManagerService } from '../../BroadcastManager.service';
import { ModalData, VoiceModalData, options } from '../ModalData';
import { FormGroup } from "@angular/forms";
import { FormBuilder, Validators } from "@angular/forms";

@Component({
    selector: 'app-modal-prompt',
    templateUrl: 'modal.prompt.html'
})
export class ModalPromptComponent {
    public onClose: Subject<boolean>
    public modalDataObj: ModalData;
    public voiceModalDataObj: VoiceModalData;
    promtForm: FormGroup;

    get f() {
        return this.promtForm.controls;
      }

    public ngOnInit(): void {
        this.promtForm = this.fb.group({
            remarks: [''],
        });
        this.onClose = new Subject();

}
    constructor(
        public bsModalRef: BsModalRef,
        private $: $BroadcastManagerService,
        private fb: FormBuilder,
    ) { }
    public onConfirm(): void {
        if((this.modalDataObj && this.modalDataObj.showremarks) || (this.voiceModalDataObj && this.voiceModalDataObj.showRadioButton)) {
            this.promtForm.controls['remarks'].setValidators([Validators.required,  Validators.minLength(10)]);
            this.promtForm.controls['remarks'].updateValueAndValidity();
        }
        console.log("this.promtForm----------",this.promtForm)
        if(this.promtForm.valid) {
            console.log("Clicked Ok")
            this.onClose.next(true);
            this.bsModalRef.hide();
        }
    }
    public onCancel(): void {
    this.onClose.next(false);
    this.bsModalRef.hide();
    console.log("Clicked Cancel")
}
    // emitEv(name: string): void {
    //     this.$.emit({
    //         click: name
    //     });
    //     this.bsModalRef.hide();
    // }
}
